/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const ComposeAltSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20.005 2.146a.5.5 0 0 1 .707 0l1.074 1.075a.5.5 0 0 1 0 .707l-1.06 1.06-1.782-1.78 1.06-1.062Zm.341 3.222-1.781-1.782-1.58 1.58A2.995 2.995 0 0 0 16 5H5a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3V8c0-.382-.072-.748-.202-1.084l1.548-1.548Zm-1.548 1.548a3.009 3.009 0 0 0-1.813-1.75l-5.644 5.644c-.09.09-.163.194-.215.308l-1.113 2.412-.002.005a.312.312 0 0 0 .384.378l2.417-1.106a1.07 1.07 0 0 0 .311-.216l5.675-5.675Z" /></svg>);
const ComposeAltSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={ComposeAltSolidBase} {...rest} ref={ref} />);
export default ComposeAltSolid;